import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { googleAds } from "appConfig";

import AdFormPage from "..";
import CategorySelect from "./CategorySelect";
import {
  selectCurrentCategories,
  selectCurrentModule,
  selectModuleByName
} from "../../App/selectors";
import StepHeader from "../StepHeader";
import BackButton from "../StepHeader/BackButton";
import history from "../../../history";
import styles from "./selectingCategory.scss";
import { PageRoute } from "../../../models";
import { POST_AD_CONTAINER_ID } from "../../../constants";
import { requireUserLogin, requireUserVerify } from "../../../routes/Auth";
import { handleAdFormLayoutMobile } from "../../../HOCs";
import { getWindowWidth, isMobileScreen } from "../../../services";
import { updateCurrentModule } from "../../App/actions";
import GoogleAd from "../../../components/GoogleAd";
import GoogleAdInterstitial from "../../../components/GoogleAdInterstitial";
import requireUsernameChange from "../../../routes/Auth/HOCs/requireUsernameChange";

const SelectingCategory = props => {
  const {
    categories,
    match: { path },
    location: { pathname },
    setCurrentModule,
    currentModule
  } = props;
  if (categories.length === 1 && pathname.endsWith(PageRoute.postAd)) {
    return <Redirect to={`${path}/${categories[0].name}`} />;
  }

  // If you reload the page, currentModule would be lost, so we are
  // extracting it from the URL and setting it to redux to load categories
  if (currentModule == "") {
    setCurrentModule(pathname.split("/")[1]);
  }

  const isMobile = isMobileScreen(getWindowWidth());

  return (
    <div id={POST_AD_CONTAINER_ID}>
      <React.Fragment>
        {isMobile && (
          <GoogleAdInterstitial
            config={{
              ...googleAds.interstitialSlot,
              id: "googleAds.interstitialSlot"
            }}
          />
        )}
        <Switch>
          <Route path={path} exact>
            <React.Fragment>
              <StepHeader
                leftButton={<BackButton onClick={() => history.goBack()} />}
              />
              <div className={styles.container}>
                {isMobile ? null : (
                  <GoogleAd
                    className={styles.ads}
                    config={{
                      ...googleAds.postAd.top,
                      id: "googleAds.postAd.top"
                    }}
                  />
                )}
                <div className={styles.title}>
                  {"Odaberite kategoriju"}
                </div>
                <CategorySelect
                  path={path}
                  categories={categories}
                  isMobile={isMobile}
                />
                {isMobile ? null : (
                  <GoogleAd
                    className={styles.ads}
                    config={{
                      ...googleAds.postAd.bottom,
                      id: "googleAds.postAd.bottom"
                    }}
                  />
                )}
              </div>
            </React.Fragment>
          </Route>
          {categories.map(category => (
            <Route
              key={category.name}
              path={`${path}/${category.route}`}
              component={AdFormPage}
            />
          ))}
        </Switch>
      </React.Fragment>
    </div>
  );
};

SelectingCategory.defaultProps = {
  module: {}
};

const connectedComponent = connect(
  state => ({
    module: selectModuleByName(state, selectCurrentModule(state)),
    categories: selectCurrentCategories(state),
    currentModule: selectCurrentModule(state)
  }),
  dispatch => ({
    setCurrentModule: module => dispatch(updateCurrentModule(module))
  })
)(handleAdFormLayoutMobile(SelectingCategory));

export default requireUserLogin(
  requireUsernameChange(
    requireUserVerify(
      connectedComponent
    )
  ),

);



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/SelectingCategory/index.tsx